module.exports = __webpack_public_path__ + "img/Leap Learning Lab Training Guide - SWAHILI p1.c3c126ff.png";